// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "-" + {"1583":"1016ab87","1783":"d6590292"}[chunkId] + ".css";
};